// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup_popup__1V0t2"};